import CoreService from '@/core/core.service.js';

export const actions = {
  getUserInfo: ({ commit }) => {
    return new Promise((resove, reject) => {
      CoreService.getUserInfo().then(response => {
        commit('SET_USER_INFO', response);
        resove(response);
      }, error => {
        reject(error);
      });
    });
  }
};
